//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailMixin from './detailMixin';
import overviewEditMixin from './overviewEditMixin';
import SocketMixin from './socketMixin';
import get from 'lodash/get';
import has from 'lodash/has';
export default {
  name: 'CoreDtwinDetailPublicMap',
  mixins: [SocketMixin, overviewEditMixin, DetailMixin],
  props: {},
  data: function data() {
    return {
      showDescription: true
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.dtwin, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.dtwin.data.twinImageId);
      }
      return './img/transparent.png';
    },
    hasHeaderBG: function hasHeaderBG() {
      return get(this.dtwin, 'data.twinImageId');
    },
    parallaxHeight: function parallaxHeight() {
      return 100;
    },
    isDescription: function isDescription() {
      return has(this.dtwin, 'data.description') && get(this.dtwin, 'data.description') !== '';
    }
  },
  watch: {},
  methods: {}
};